export default __webpack_public_path__ + "fonts/d39dc2021477e5fbaae37a45550b10ff.svg";